import ActivationStatusAction from "./actions";

const initialState = {
    activationStatusResult: [],
    activationStatusLoading: false,
    activationStatusError: null
};

export default function activationStatusReducer(
    state = initialState,
    action
) {

    switch (action.type) {

        case ActivationStatusAction.GET_ACTIVATION_STATUS:

            return {
                ...state,
                activationStatusLoading: true,
                activationStatusResult: [],
                activationStatusError: null
            };


        case ActivationStatusAction.GET_ACTIVATION_STATUS_SUCCESS:

            console.log(
                "REDUCER SUCCESS DATA:",
                action.payload
            );

            return {
                ...state,
                activationStatusLoading: false,
                activationStatusResult: action.payload,
                activationStatusError: null
            };


        case ActivationStatusAction.GET_ACTIVATION_STATUS_FAILURE:

            return {
                ...state,
                activationStatusLoading: false,
                activationStatusResult: [],
                activationStatusError: action.payload
            };


        default:
            return state;
    }
}